import {
  DEFAULT_NUMBER_SINGLE_COLOR,
  DEFAULT_THEME,
  NUMBER_SINGLE_COLOR_THEME_KEY,
} from 'src/constants';

// Table themes (shared by both table and pivotTable)
const tableThemes = {
  'Shipsy Blue_Dark': [
    '#0E1E38', // columnHeaderBackground
    '#FFFFFF', // columnHeaderFont
    '#FFFFFF', // rowsBackground
    '#FFFFFF', // rowsFontColor
    '#0F172A', // alternateRowsColor
    '#E5E7EB', // columnsHeaderBorderColor 
    '#E5E7EB', // cellBorderColor
    
  ],
  'Shipsy Blue_Light': [
    '#EAF2FF',
    '#0B3954',
    '#FFFFFF',
    '#FFFFFF',
    '#0F172A',
    '#CBD5E1',
    '#E5E7EB',
  ],
  teal_breeze: [
    '#ECFDF5',
    '#0F766E',
    '#FFFFFF',
    '#FFFFFF',
    '#0F172A',
    '#A7F3D0',
    '#D1FAE5',
  ],
  stone_neutral: [
    '#FAF7F2',
    '#3F3A34',
    '#FFFFFF',
    '#FFFFFF',
    '#3F3A34',
    '#E7E0D7',
    '#EDEAE5',
  ],
  coral_wave: [
    '#FFE4E6',
    '#BE123C',
    '#FFFFFF',
    '#FFFFFF',
    '#1F2937',
    '#FDA4AF',
    '#FECDD3',
  ],
  ' aqua_sky': [
    '#ECFEFF',
    '#0E7490',
    '#FFFFFF',
    '#FFFFFF',
    '#0F172A',
    '#67E8F9',
    '#A5F3FC',
  ],
  
};

// Chart themes (shared across bar, pie, line, number)
const baseChartThemes = {
  'Shipsy Blue_Dark': [
    '#162D4F', // deep navy
    '#5384CD', // mid blue
    '#dde7f5', // neutral
    '#DC9273', // warm tan
    '#512614', // deep brown
  ],
  'Ocean blue (5)': ['#01161e', '#124559', '#598392', '#aec3b0', '#d0e6dd'],
  'summer sunset (5)': ['#ff6b35', '#f7c59f', '#ead9c2', '#004e89', '#1a659e'],
  'Ocean Sunset (10)': [
    '#001219',
    '#005f73',
    '#0a9396',
    '#94d2bd',
    '#e9d8a6',
    '#ee9b00',
    '#ca6702',
    '#bb3e03',
    '#ae2012',
    '#9b2226',
  ],
  'Refreshing Summer (10)': [
    '#0e1e38',
    '#3288bd',
    '#66c2a5',
    '#abdda4',
    '#e6f598',
    '#fee08b',
    '#fdae61',
    '#f46d43',
    '#d53e4f',
    '#9e0142',
  ],
  'Soft sand (10)': [
    '#74AA84',
    '#F68E5F',
    '#B3EEFF',
    '#F89C73',
    '#E5D6C5',
    '#488799',
    '#81B1A9',
    '#2E4052',
    '#74E3FB',
    '#323934',
  ],
  'Shipsy Blue (20)': [
    '#0E1E38',
    '#162D4F',
    '#214273',
    '#2B5697',
    '#366BBB',
    '#5384CD',
    '#779ED7',
    '#9CB8E2',
    '#dde7f5',
    '#E5AF98',
    '#DC9273',
    '#D2754E',
    '#C15C30',
    '#9C4A27',
    '#76381D',
    '#512614',
  ],
  'Vibrant Pastel (20)': [
    '#5B8FF9',
    '#CDDDFD',
    '#61DDAA',
    '#CDF3E4',
    '#65789B',
    '#CED4DE',
    '#F6BD16',
    '#FCEBB9',
    '#7262fd',
    '#D3CEFD',
    '#78D3F8',
    '#D3EEF9',
    '#9661BC',
    '#DECFEA',
    '#F6903D',
    '#FFE0C7',
    '#008685',
    '#BBDEDE',
    '#F08BB4',
    '#FFE0ED',
  ],
  'Soft Pastel (20)': [
    '#FCA5A5',
    '#FDBA74',
    '#FCD34D',
    '#FDE047',
    '#BEF264',
    '#86EFAC',
    '#6EE7B7',
    '#5EEAD4',
    '#67E8F9',
    '#7DD3FC',
    '#93C5FD',
    '#A5B4FC',
    '#C4B5FD',
    '#D8B4FE',
    '#F0ABFC',
    '#F9A8D4',
    '#FDA4AF',
    '#CBD5E1',
    '#D6D3D1',
    '#D1D5DB',
  ],

  'Muted Professional (20)': [
    '#0E1E38',
    '#30597A',
    '#4E8AC9',
    '#6CA0DC',
    '#8CB7E8',
    '#A3C2D8',
    '#7FB8A8',
    '#5C9D7A',
    '#A0C65C',
    '#D4DA68',
    '#E2B75D',
    '#DB8852',
    '#C75C48',
    '#9C3C52',
    '#6A2E5F',
  ],
  theme_4: [
    '#5B8FF9',
    '#CDDDFD',
    '#61DDAA',
    '#CDF3E4',
    '#65789B',
    '#CED4DE',
    '#F6BD16',
    '#FCEBB9',
    '#7262fd',
    '#D3CEFD',
    '#78D3F8',
    '#D3EEF9',
    '#9661BC',
    '#DECFEA',
    '#F6903D',
    '#FFE0C7',
    '#008685',
    '#BBDEDE',
    '#F08BB4',
    '#FFE0ED',
  ],
  theme_3: [
    '#FF6B3B',
    '#626681',
    '#FFC100',
    '#9FB40F',
    '#76523B',
    '#DAD5B5',
    '#0E8E89',
    '#E19348',
    '#F383A2',
    '#247FEA',
    '#2BCB95',
    '#B1ABF4',
    '#1D42C2',
    '#1D9ED1',
    '#D64BC0',
    '#255634',
    '#8C8C47',
    '#8CDAE5',
    '#8E283B',
    '#791DC9',
  ],
  theme_2: [
    '#025DF4',
    '#DB6BCF',
    '#2498D1',
    '#BBBDE6',
    '#4045B2',
    '#21A97A',
    '#FF745A',
    '#007E99',
    '#FFA8A8',
    '#2391FF',
    '#FFC328',
    '#A0DC2C',
    '#946DFF',
    '#626681',
    '#EB4185',
    '#CD8150',
    '#36BCCB',
    '#327039',
    '#803488',
    '#83BC99',
  ],
  theme_1: [
    '#1478FF',
    '#FF9B14',
    '#FF4500',
    '#1AAF8B',
    '#406C85',
    '#F6BD16',
    '#B40F0F',
    '#2FB8FC',
    '#4435FF',
    '#FF5CA2',
    '#BBE800',
    '#FE8A26',
    '#946DFF',
    '#6C3E00',
    '#6193FF',
    '#FF988E',
    '#36BCCB',
    '#004988',
    '#FFCF9D',
    '#CCDC8A',
    '#8D00A1',
    '#1CC25E',
  ],
};

const numberChartThemes = {
  ...baseChartThemes,
  [NUMBER_SINGLE_COLOR_THEME_KEY]: [DEFAULT_NUMBER_SINGLE_COLOR],
};

// Master chartThemes object
export const chartThemes = {
  bar: baseChartThemes,
  pie: baseChartThemes,
  line: baseChartThemes,
  number: numberChartThemes,
  table: tableThemes,
  pivotTable: tableThemes, // reuse table themes
};
// Utility function to get theme options for a specific chart type
export const getThemeOptions = (chartType: string) => {
  const themes = chartThemes[chartType] || chartThemes.bar; // fallback to bar themes
  //so that the old reports are not affected
  // Filter out legacy themes for bar, pie, and number charts
  const legacyThemes = ['theme_1', 'theme_2', 'theme_3', 'theme_4'];
  const shouldHideLegacyThemes = ['bar', 'pie', 'number', 'line'].includes(chartType);

  const filteredThemeKeys = shouldHideLegacyThemes
    ? Object.keys(themes).filter((themeKey) => !legacyThemes.includes(themeKey))
    : Object.keys(themes);

  return filteredThemeKeys.map((themeKey) => ({
    value: themeKey,
    label: themeKey.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase()),
  }));
};

// Utility function to get theme count for a specific chart type
export const getThemeCount = (chartType: string) => {
  const themes = chartThemes[chartType] || chartThemes.bar;
  //so that the old reports are not affected
  // Filter out legacy themes for bar, pie, and number charts (same logic as getThemeOptions)
  const legacyThemes = ['theme_1', 'theme_2', 'theme_3', 'theme_4'];
  const shouldHideLegacyThemes = ['bar', 'pie', 'number', 'line'].includes(
    chartType,
  );

  const filteredThemeKeys = shouldHideLegacyThemes
    ? Object.keys(themes).filter((themeKey) => !legacyThemes.includes(themeKey))
    : Object.keys(themes);

  return filteredThemeKeys.length;
};

export const tableColor = chartThemes.table[DEFAULT_THEME];
